"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeObject = exports.totangoTheme = exports.totangoThemeNew = void 0;
const styles_1 = require("@material-ui/core/styles");
const themeColors_1 = require("./themeColors");
const { borderColor, disabledBG, errorColor, mainColor, primaryColor, secondaryColor, totangoBlack, totangoGray500, totangoGreen, totangoGreen200, totangoTextBtnHover, whiteColor, } = themeColors_1.themeColors;
const isFaultyChromeVersion = () => {
    try {
        const myNavigator = navigator;
        const [major, , patch, minorPatch] = myNavigator.userAgent
            .match(/Chrome\/(([0-9]+\.?)+)/)[1]
            .split('.')
            .map((s) => parseInt(s, 10));
        return major === 87 && patch === 4280 && minorPatch >= 66;
    }
    catch (e) {
        return false;
    }
};
const textBtnStyle = {
    color: totangoGreen,
    borderColor: totangoGreen,
    '&:hover': {
        backgroundColor: totangoTextBtnHover,
    },
    '&.danger': {
        color: '#EA6153',
        backgroundColor: 'transparent',
        borderColor: '#EA6153',
        '&:hover': {
            backgroundColor: 'rgba(234, 97, 83, 0.07)',
        },
    },
};
const themeOverrides = {
    spacing: 4,
    typography: {
        useNextVariants: true,
        fontFamily: [
            '"Poppins-Regular"',
            'sans-serif',
            '-apple-system',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        color: mainColor,
        h1: {
            fontSize: '3.7rem',
            fontFamily: 'Poppins-Light',
            lineHeight: '78px',
            letterSpacing: '-1.5px',
        },
        h2: {
            fontSize: '2.28rem',
            lineHeight: '48px',
            letterSpacing: '-1px',
        },
        h3: {
            fontSize: '1.7rem',
            lineHeight: '36px',
        },
        h4: {
            fontSize: '1.28rem',
            lineHeight: '28px',
        },
        h5: {
            fontSize: '1.28rem',
            lineHeight: '28px',
            fontFamily: 'Poppins-Medium',
        },
        h6: {
            fontSize: '1.25rem',
            lineHeight: '1.6',
            fontFamily: 'Poppins-Regular',
        },
        subtitle1: {
            fontSize: '1.14rem',
            fontFamily: 'Poppins-Medium',
            lineHeight: '24px',
            letterSpacing: 'normal',
        },
        subtitle2: {
            fontSize: '1.14rem',
            lineHeight: '28px',
            letterSpacing: 'normal',
        },
        body1: {
            fontSize: '1rem',
            lineHeight: '24px',
            letterSpacing: 'normal',
        },
        body2: {
            fontSize: '1rem',
            fontFamily: 'Poppins-Medium',
            letterSpacing: 'normal',
        },
        caption: {
            fontSize: '0.85rem',
            lineHeight: '18px',
            letterSpacing: 'normal',
        },
        overline: {
            fontSize: '0.85rem',
            lineHeight: '18px',
            fontFamily: 'Poppins-SemiBold',
            display: 'inline-block',
            letterSpacing: 'normal',
            textTransform: 'initial',
            '&.button-typography': {
                textTransform: 'uppercase',
            },
        },
    },
    palette: {
        type: 'light',
        text: {
            primary: mainColor,
        },
        primary: {
            main: primaryColor,
            contrastText: '#fff',
        },
        secondary: {
            main: secondaryColor,
            contrastText: '#fff',
        },
        cancel: {
            main: errorColor,
            contrastText: '#fff',
        },
        error: {
            main: errorColor,
        },
    },
    overrides: {
        MuiButton: {
            contained: {
                boxShadow: 'none',
            },
            text: textBtnStyle,
            textPrimary: textBtnStyle,
            textSecondary: textBtnStyle,
            outlinedPrimary: textBtnStyle,
            containedPrimary: {
                backgroundColor: totangoGreen,
                '&:hover': {
                    backgroundColor: totangoGreen200,
                },
            },
            root: {
                '&.danger': {
                    backgroundColor: '#EA6153',
                },
                '&.danger:hover': {
                    backgroundColor: '#F46B5D',
                },
            },
        },
        MuiAutocomplete: {
            inputRoot: {
                height: '40px',
                '&&[class*="MuiOutlinedInput-root"] $input': {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                },
            },
            endAdornment: {
                top: '50%',
                transform: 'translateY(-50%)',
            },
        },
        MuiFormLabel: {
            root: {
                color: totangoBlack,
                fontSize: 13,
            },
        },
        MuiFormControlLabel: {
            root: {
                marginBottom: '0px',
            },
        },
        MuiTableCell: {
            root: {
                fontFamily: 'Poppins-Regular',
            },
        },
        MuiTableSortLabel: {
            root: {
                fontSize: 13,
            },
        },
        MuiSlider: {
            root: {
                color: '#3a8589',
                height: 3,
                padding: '13px 0',
            },
            thumb: {
                height: 16,
                width: 16,
                backgroundColor: '#fff',
                border: '1px solid currentColor',
                marginTop: -8,
                marginLeft: -8,
                boxShadow: '#ebebeb 0px 2px 2px',
                '&:focus,&:hover,&$active': {
                    boxShadow: '#ccc 0px 2px 3px 1px',
                },
                '& .bar': {
                    height: 5,
                    width: 1,
                    backgroundColor: 'currentColor',
                    marginLeft: 1,
                    marginRight: 1,
                },
            },
            active: {},
            valueLabel: {
                left: 'calc(-50% + 4px)',
            },
            track: {
                height: 1,
                color: '#9B9B9B',
            },
            rail: {
                color: '#9B9B9B',
                opacity: 1,
                height: 1,
            },
        },
        MuiSelect: {
            root: {
                height: 40,
            },
            select: {
                paddingRight: 32,
                '&&': {
                    paddingRight: 32,
                },
            },
            selectMenu: {
                padding: '12px 35px 11px 15px',
                color: totangoBlack,
            },
        },
        MuiMenuItem: {
            root: {
                fontSize: '13px',
                'min-height': 40,
                '@media (min-width: 600px)': {
                    'min-height': 40,
                },
            },
        },
        MuiTextField: {
            root: {
                '& label': {
                    color: totangoGray500,
                },
                '& label.Mui-focused': {
                    color: primaryColor,
                },
                '& label.Mui-error': {
                    color: errorColor,
                },
            },
        },
        MuiFormHelperText: {
            contained: {
                marginLeft: 4,
            },
        },
        MuiChip: {
            root: {
                fontFamily: 'Poppins-Regular',
            },
        },
        MuiOutlinedInput: {
            root: {
                backgroundColor: whiteColor,
                borderColor,
                '& legend': {
                    border: 'none',
                },
                '& $notchedOutline': {
                    borderColor,
                    ...(isFaultyChromeVersion() && {
                        borderRadius: 'unset',
                    }),
                },
                '&:hover $notchedOutline': {
                    borderColor: primaryColor,
                },
                '&.Mui-focused $notchedOutline': {
                    border: `1px solid ${primaryColor}`,
                },
                '&.Mui-disabled fieldset': {
                    backgroundColor: disabledBG,
                },
            },
            notchedOutline: {
                '& legend span': {
                    padding: 0,
                },
            },
            input: {
                padding: '7.5px 14px',
            },
        },
        MuiInput: {
            formControl: {
                'label + &': {
                    marginTop: 0,
                },
            },
        },
        MuiInputBase: {
            root: {
                minHeight: 40,
                color: totangoBlack,
                '& .fa': {
                    color: borderColor,
                },
            },
            input: {
                borderColor: primaryColor,
                padding: '7.5px 14px',
                fontSize: 13,
            },
        },
        MuiCheckbox: {
            colorPrimary: {
                '&.Mui-checked.MuiCheckbox-root': {
                    color: primaryColor,
                },
            },
        },
        MuiInputLabel: {
            root: {
                zIndex: 1,
                pointerEvents: 'none',
            },
            shrink: {
                transform: ['translate(12px, -4px) scale(0.75)', '!important'],
                '&.Mui-focused': {
                    color: primaryColor,
                },
            },
            animated: {
                transform: 'translate(12px, 14px) scale(1)',
                color: totangoGray500,
            },
            outlined: {
                transform: 'translate(11px, 15px) scale(1)',
            },
        },
        MuiToggleButtonGroup: {
            root: {
                verticalAlign: 'middle',
                border: `1px solid ${borderColor}`,
                boxShadow: 'none',
            },
        },
        MuiListItem: {
            root: {
                '&$selected': {
                    color: mainColor,
                    boxShadow: 'none',
                    whiteSpace: 'pre-wrap',
                },
                fontSize: '13px',
                'min-height': 40,
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '0.8rem',
                fontFamily: 'Poppins-Regular, sans-serif',
            },
        },
        MuiListItemIcon: {
            root: {
                'min-width': '35px',
            },
        },
        MuiTabs: {
            root: {
                'min-height': '35px',
            },
            indicator: {
                height: '4px',
                'background-color': primaryColor,
            },
        },
        MuiTab: {
            root: {
                'min-height': '35px',
                minWidth: 'auto',
                paddingLeft: '15px',
                paddingRight: '15px',
                '@media (min-width: 600px)': {
                    minWidth: 'auto',
                },
            },
        },
        MuiSkeleton: {
            root: {
                '&.MuiSkeleton-wave::after': {
                    background: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent)',
                },
            },
        },
    },
};
exports.themeObject = themeOverrides;
const totangoThemeNew = (0, styles_1.createTheme)(themeOverrides);
exports.totangoThemeNew = totangoThemeNew;
const totangoTheme = (0, styles_1.createMuiTheme)(themeOverrides);
exports.totangoTheme = totangoTheme;
//# sourceMappingURL=totangoTheme.js.map